<template>
  <div id="nav">
    <div class="nav-bar">
      <!-- 左侧：Logo + 平台名称 -->
    <div class="nav-logo" @click="goHome">
        <div class="logo-icon">农</div>
        <span class="logo-text">安康市涉农信用信息平台</span>
      </div>

      <!-- 中间：导航菜单 -->
      <div class="nav-menu">
        <div
          v-for="(item, index) in navList"
          :key="index"
          class="nav-item"
          :class="{ active: isActive(item) }"
          @click="navigateTo(item)"
        >
          <span>{{ item.name }}</span>
        </div>
      </div>
      <!-- 右侧：用户信息 -->
      <div class="nav-user">
        <!-- 已登录的中小企业用户 -->
        <template v-if="token && userInfoweb && userInfoweb.type == 4">
          <MessageBell />
          <div class="user-info" @click="togo('work')">
            <div class="user-avatar-icon">
              <img src="@/assets/img/2026/avator.png" alt="">
            </div>
            <span class="user-name">{{ userInfoweb.account }}</span>
          </div>
          <span class="logout-btn" @click="logout">退出</span>
        </template>

        <!-- 已登录的金融机构用户 -->
        <template v-else-if="token && userInfoweb && userInfoweb.type == 5">
          <MessageBell />
          <div class="user-info" @click="togo('staging')">
            <div class="user-avatar-icon">
              <img src="@/assets/img/2026/avator.png" alt="">
            </div>
            <span class="user-name">{{ userInfoweb.account }}</span>
          </div>
          <span class="logout-btn" @click="logout">退出</span>
        </template>

        <!-- 未登录 -->
        <template v-else>
          <!-- 中小企业下拉 -->
          <div class="custom-dropdown">
            <span class="login-btn">中小企业</span>
            <div class="custom-dropdown-menu">
              <div class="custom-dropdown-item" @click="handleCommand('login')">立即登录</div>
              <div class="custom-dropdown-item" @click="handleCommand('register')">企业注册</div>
            </div>
          </div>

          <!-- 金融机构下拉 -->
          <div class="custom-dropdown">
            <span class="login-btn">金融机构</span>
            <div class="custom-dropdown-menu">
              <div class="custom-dropdown-item" @click="handleCommand('loginOrgan')">立即登录</div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
/* API 导入 */
import { logOut } from "@/api/index";
import MessageBell from "@/components/MessageBell.vue";
export default {
  name: "topNav",
  components: { MessageBell },
  data() {
    return {
      userInfoweb: this.$store.state.system.userInfoweb,
      token: this.$store.state.system.token,
      navList: [
        { name: "首页", path: "/home" },
        { name: "政策解读", path: "/news" },
        { name: "融资服务", path: "/products" },
        { name: "融资需求", path: "/needs" },
        { name: "机构信息", path: "/organ" },
        { name: "平台介绍", path: "/aboutUs" },
      ],
    };
  },
  methods: {
    /** 判断导航项是否处于激活状态 */
    isActive(item) {
      if (item.path === "/home") {
        return this.$route.path === "/home" || this.$route.path === "/";
      }
      return this.$route.path.startsWith(item.path);
    },

    /** 导航跳转 */
    navigateTo(item) {
      this.$router.push(item.path);
    },

    /** 回到首页 */
    goHome() {
      this.$router.push("/home");
    },

    /** 处理下拉菜单命令 */
    handleCommand(command) {
      if (command === "login") this.login("login", 1);
      else if (command === "register") this.register();
      else if (command === "loginOrgan") this.login("login", 2);
    },

    /** 跳转登录页 */
    login(name, type) {
      if (name === this.$route.name) return;
      this.$router.push({ name, query: { type } });
    },

    /** 跳转到指定页面 */
    togo(path) {
      this.$router.push({ name: path });
    },

    /** 跳转注册页 */
    register() {
      this.$router.push("/register");
    },

    /** 退出登录 */
    logout() {
      this.$confirm("确认退出吗？", "提示", {
        dangerouslyUseHTMLString: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        logOut().then(() => {
          this.$store.dispatch("setToken", "");
          this.$store.dispatch("setUserInfo", "");
          this.userInfoweb = this.$store.state.system.userInfoweb;
          this.token = this.$store.state.system.token;
          this.$router.push("/home");
        });
      });
    },
  },

  mounted() {},
};
</script>

<style scoped>
#nav {
  width: 100%;
  z-index: 1000;
  position: fixed;
  top: 0;
}

.nav-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 70px;
  padding: 0 30px;
  background: #ffffff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

/* 左侧 Logo 区域 */
.nav-logo {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  flex-shrink: 0;
}

.logo-icon {
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-weight: bold;
  border-radius: 10px;
  background: linear-gradient(135deg, #1366ec 0%, #1366ec 100%);
  box-shadow: 0px 1px 2px -1px rgba(0, 0, 0, 0.1),
    0px 1px 3px 0px rgba(0, 0, 0, 0.1);
}

.logo-text {
  font-family: "Noto Sans SC", sans-serif;
  font-weight: 700;
  font-size: 20px;
  line-height: 25px;
  letter-spacing: 0.025em;
  color: #000000;
}

/* 中间导航菜单 */
.nav-menu {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
  gap: 0;
  margin-left: 40px;
}

.nav-item {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 129px;
  height: 69px;
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
}

.nav-item span {
  font-family: "PingFang SC", sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 25px;
  letter-spacing: 0.0357em;
  color: rgba(0, 0, 0, 0.4);
  transition: color 0.3s;
}

.nav-item:hover span {
  color: rgba(0, 0, 0, 0.7);
}

/* 激活状态的导航项 */
.nav-item.active {
  position: relative;
}

.nav-item.active::before {
  content: "";
  position: absolute;
  width: 110px;
  height: 44px;
  border-radius: 46px;
  background: #0077ff;
  background-image: radial-gradient(
      circle at 50% 0%,
      rgba(0, 139, 255, 1) 0%,
      rgba(0, 139, 255, 0) 100%
    ),
    radial-gradient(
      circle at 50% 100%,
      rgba(113, 87, 254, 1) 0%,
      rgba(113, 87, 254, 0) 100%
    );
  box-shadow: 0px 5px 5px 0px rgba(19, 102, 236, 0.13),
    inset 0px 0px 7.9px 0px rgba(255, 255, 255, 1);
  z-index: 0;
}

.nav-item.active span {
  color: #ffffff;
  position: relative;
  z-index: 1;
}

/* 右侧用户信息区域 */
.nav-user {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-shrink: 0;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
}

.user-avatar-icon {
  width: 24px;
  height: 24px;
  /* border-radius: 17px;
  background: #1366ec; */
}

 .user-avatar-icon img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.user-name {
  font-family: "PingFang SC", sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: #1366ec;
}

.logout-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 72px;
  height: 27px;
  background: #ffffff;
  border: 1px solid #dcdfe6;
  border-radius: 33px;
  font-family: "PingFang SC", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #606266;
  cursor: pointer;
  transition: all 0.3s;
}

.logout-btn:hover {
  border-color: #1366ec;
  color: #1366ec;
}

/* 未登录按钮样式 */
.login-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 5px 16px;
  background: #ffffff;
  border: 1px solid #dcdfe6;
  border-radius: 33px;
  font-family: "PingFang SC", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #606266;
  cursor: pointer;
  transition: all 0.3s;
}

.login-btn:hover {
  border-color: #1366ec;
  color: #1366ec;
}

/* 自定义下拉菜单（替代 el-dropdown，避免 fixed 定位下 Popper 失效） */
.custom-dropdown {
  position: relative;
  display: inline-block;
}

.custom-dropdown-menu {
  position: absolute;
  top: calc(100% + 6px);
  left: 50%;
  min-width: 120px;
  background: #ffffff;
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 6px 0;
  visibility: hidden;
  opacity: 0;
  transform: translateX(-50%) translateY(-6px);
  transition: opacity 0.2s ease, transform 0.2s ease, visibility 0.2s;
  z-index: 1001;
}

.custom-dropdown:hover .custom-dropdown-menu {
  visibility: visible;
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}

.custom-dropdown-item {
  padding: 8px 16px;
  cursor: pointer;
  font-family: "PingFang SC", sans-serif;
  font-size: 14px;
  line-height: 22px;
  color: #606266;
  transition: background 0.2s, color 0.2s;
  white-space: nowrap;
  text-align:center;
}

.custom-dropdown-item:hover {
  background: #ecf5ff;
  color: #1366ec;
}

/* 动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
